import { render, staticRenderFns } from "./sjjy3.vue?vue&type=template&id=0f3a5d44&scoped=true&"
import script from "./sjjy3.vue?vue&type=script&lang=js&"
export * from "./sjjy3.vue?vue&type=script&lang=js&"
import style0 from "./sjjy3.vue?vue&type=style&index=0&id=0f3a5d44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a5d44",
  null
  
)

export default component.exports